/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsFacebookGames.js.map